'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Pin$() {
  this.c8d = null;
  this.c8e = false;
  this.c8f = null;
  this.c8g = false;
}
export { $c_Lpresto_types$Pin$ as $c_Lpresto_types$Pin$ };
$p = $c_Lpresto_types$Pin$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Pin$;
/** @constructor */
function $h_Lpresto_types$Pin$() {
}
export { $h_Lpresto_types$Pin$ as $h_Lpresto_types$Pin$ };
$h_Lpresto_types$Pin$.prototype = $p;
$p.zf = (function() {
  if ((!this.c8e)) {
    this.c8d = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD;
    this.c8e = true;
  }
  return this.c8d;
});
$p.T1 = (function(value) {
  var trimmed = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__trim__T(value);
  if (((trimmed.length < 4) || (trimmed.length > 8))) {
    return true;
  } else {
    _return: {
      var len = trimmed.length;
      var i = 0;
      while ((i < len)) {
        if ((!$j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_jl_Character$().GT(trimmed.charCodeAt(i)))) {
          var $x_1 = i;
          break _return;
        }
        i = ((1 + i) | 0);
      }
      var $x_1 = (-1);
    }
    return ($x_1 !== (-1));
  }
});
$p.cuu = (function(pin) {
  return (this.T1(pin) ? new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), (("Pin is not valid '" + pin) + "'"))) : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(pin));
});
$p.csu = (function() {
  if ((!this.c8g)) {
    this.c8f = new $c_Lpresto_types$Pin$$anon$83(this);
    this.c8g = true;
  }
  return this.c8f;
});
var $d_Lpresto_types$Pin$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Pin$, "presto.types$Pin$", ({
  a0I: 1,
  D: 1
}));
export { $d_Lpresto_types$Pin$ as $d_Lpresto_types$Pin$ };
var $n_Lpresto_types$Pin$;
function $m_Lpresto_types$Pin$() {
  if ((!$n_Lpresto_types$Pin$)) {
    $n_Lpresto_types$Pin$ = new $c_Lpresto_types$Pin$();
  }
  return $n_Lpresto_types$Pin$;
}
export { $m_Lpresto_types$Pin$ as $m_Lpresto_types$Pin$ };
/** @constructor */
function $c_Lpresto_types$Pin$$anon$83(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$Pin$$anon$83 as $c_Lpresto_types$Pin$$anon$83 };
$p = $c_Lpresto_types$Pin$$anon$83.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Pin$$anon$83;
/** @constructor */
function $h_Lpresto_types$Pin$$anon$83() {
}
export { $h_Lpresto_types$Pin$$anon$83 as $h_Lpresto_types$Pin$$anon$83 };
$h_Lpresto_types$Pin$$anon$83.prototype = $p;
$p.bn = (function(it) {
  return $m_Lpresto_types$Pin$().cuu(it).cL(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((t) => t)));
});
$p.bN = (function(text) {
  return $m_Lpresto_types$Pin$().cuu(text);
});
$p.bJ = (function(t) {
  return this.bn(t);
});
var $d_Lpresto_types$Pin$$anon$83 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Pin$$anon$83, "presto.types$Pin$$anon$83", ({
  a0J: 1,
  K: 1
}));
export { $d_Lpresto_types$Pin$$anon$83 as $d_Lpresto_types$Pin$$anon$83 };
//# sourceMappingURL=presto.types$-Pin$.js.map
